var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.22222H18V20H3.375C1.5075 20 0 18.5111 0 16.6667V3.33333C0 1.48889 1.5075 0 3.375 0H13.5V15.5556H3.375C2.75625 15.5556 2.25 16.0556 2.25 16.6667C2.25 17.2778 2.75625 17.7778 3.375 17.7778H15.75V2.22222Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseIcon);
export default __webpack_public_path__ + "static/media/course_icon.acb8c726e8f78479db8038c6cbfe904e.svg";
export { ForwardRef as ReactComponent };